import { Routes } from '@angular/router';

export const subscriptionRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./subscriptions.page').then((m) => m.SubscriptionsPage),
  },
  {
    path: 'failed-payment',
    loadComponent: () =>
      import('./subscription-management-failed-payment/subscription-management-failed-payment.page').then(
        (m) => m.SubscriptionManagementFailedPaymentPage,
      ),
    data: {
      background: 'assets/splash_bck.png',
      shouldShowTabBar: false,
    },
  },
  {
    path: ':programId',
    loadComponent: () => import('./manage-subscription/manage-subscription.page').then((m) => m.ManageSubscriptionPage),
    data: {
      shouldShowTabBar: false,
    },
  },
  {
    path: ':programId/failed-payment',
    loadComponent: () =>
      import('./subscription-management-failed-payment/subscription-management-failed-payment.page').then(
        (m) => m.SubscriptionManagementFailedPaymentPage,
      ),
    data: {
      background: 'assets/splash_bck.png',
      shouldShowTabBar: false,
    },
  },
  {
    path: ':programId/confirmation',
    loadComponent: () =>
      import('../../payment-subscription/payment-confirmation/payment-confirmation.component').then(
        (m) => m.PaymentConfirmationComponent,
      ),
    data: {
      canGoBack: true,
      shouldShowTabBar: false,
    },
  },
  {
    path: ':programId/shipping-address',
    loadComponent: () =>
      import('./subscription-shipping-address/subscription-shipping-address.page').then(
        (m) => m.SubscriptionShippingAddressPage,
      ),
    data: {
      shouldShowTabBar: false,
    },
  },
  {
    path: ':programId/schedule-consultation',
    loadComponent: () =>
      import('@shared/pages/schedule-consultation/schedule-consultation.page').then((m) => m.ScheduleConsultationPage),
    data: {
      shouldShowTabBar: false,
    },
  },
  {
    path: ':programId/schedule-consultation/confirm',
    loadComponent: () =>
      import('@shared/pages/schedule-confirmation/schedule-confirmation.page').then((m) => m.ScheduleConfirmationPage),
    data: {
      shouldShowTabBar: false,
    },
  },
];
